import { WsEvent } from '@shared/api'
import { useCustomerStore } from '@entities/customer'
import { onDisciplineReady } from '@entities/customer'

export const useListenEventCustomer = (channel: any): void => {
  const customerStore = useCustomerStore()

  onDisciplineReady(() => {
    channel.listen(WsEvent.CustomerUpdated, async (): Promise<void> => {
      await customerStore.refreshNow()
    })
  })
}
